import { Button } from '@/components/ui/button'
import type { IntegrationSidebarProps } from '@/types/integration'
import { Rocket, Database, Cloud } from 'lucide-react'

export const MockSidebar = ({ onAction }: IntegrationSidebarProps) => {
  const mockProjects = [
    { id: '1', name: 'Test Project Alpha', status: 'active', count: 12 },
    { id: '2', name: 'Test Project Beta', status: 'pending', count: 5 },
    { id: '3', name: 'Test Project Gamma', status: 'completed', count: 0 },
  ]

  return (
    <div className="flex-1 overflow-y-auto min-h-0 p-3 space-y-4">
      {/* Header */}
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground px-2 mb-2">
          🧪 Mock Integration
        </h3>
        <p className="text-xs text-muted-foreground px-2">
          This is a test integration demonstrating the framework
        </p>
      </div>

      {/* Action Buttons */}
      <div className="space-y-2">
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start gap-2"
          onClick={(e) => {
            const openInNewTab = e.metaKey || e.ctrlKey
            onAction?.('open_main_view', { openInNewTab })
          }}
        >
          <Rocket className="h-4 w-4" />
          <span className="text-xs">Open Dashboard</span>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start gap-2"
          onClick={() => onAction?.('sync_data')}
        >
          <Cloud className="h-4 w-4" />
          <span className="text-xs">Sync Data</span>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start gap-2"
          onClick={() => onAction?.('view_stats')}
        >
          <Database className="h-4 w-4" />
          <span className="text-xs">View Stats</span>
        </Button>
      </div>

      {/* Mock Projects List */}
      <div>
        <h4 className="text-xs font-semibold text-muted-foreground px-2 mb-2">
          Projects ({mockProjects.length})
        </h4>
        <div className="space-y-1">
          {mockProjects.map(project => (
            <button
              key={project.id}
              onClick={(e) => {
                const openInNewTab = e.metaKey || e.ctrlKey
                onAction?.('select_project', { ...project, openInNewTab })
              }}
              className="w-full p-2 rounded-md hover:bg-accent text-left transition-colors border border-border"
            >
              <div className="text-sm font-medium">{project.name}</div>
              <div className="flex items-center gap-2 mt-1">
                <span 
                  className={`text-xs px-2 py-0.5 rounded-full ${
                    project.status === 'active' 
                      ? 'bg-green-500/10 text-green-500 border border-green-500/20' 
                      : 'bg-gray-500/10 text-gray-500 border border-gray-500/20'
                  }`}
                >
                  {project.status}
                </span>
                {project.count > 0 && (
                  <span className="text-xs text-muted-foreground">
                    {project.count} items
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Status Info */}
      <div className="border-t border-border pt-3">
        <div className="px-2 space-y-1 text-xs text-muted-foreground">
          <div className="flex justify-between">
            <span>Status:</span>
            <span className="text-green-500">● Connected</span>
          </div>
          <div className="flex justify-between">
            <span>Last Sync:</span>
            <span>2 min ago</span>
          </div>
          <div className="flex justify-between">
            <span>Total Items:</span>
            <span>17</span>
          </div>
        </div>
      </div>
    </div>
  )
}

